import { render } from "./ShopCard.vue?vue&type=template&id=85eb3ce0&scoped=true"
import script from "./ShopCard.vue?vue&type=script&lang=js"
export * from "./ShopCard.vue?vue&type=script&lang=js"

import "./ShopCard.vue?vue&type=style&index=0&id=85eb3ce0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85eb3ce0"]])

export default __exports__